export const SET_CURRENT_USER_PROFILE = "setCurrentUserProfile";
export const SET_USER_PROFILE = "setUserProfile";
export const APPEND_ALREADY_FETCHING_USER_UIDS = "appendAlreadyFetchingUserUids";
